
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internet/campaigns/[campaignName]",
      function () {
        return require("private-next-pages/internet/campaigns/[campaignName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internet/campaigns/[campaignName]"])
      });
    }
  